import { render } from "./CommandeInfo.vue?vue&type=template&id=335e9b35"
import script from "./CommandeInfo.vue?vue&type=script&lang=js"
export * from "./CommandeInfo.vue?vue&type=script&lang=js"

import "./CommandeInfo.vue?vue&type=style&index=0&id=335e9b35&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__